import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import MdEditor from 'react-markdown-editor-lite';
import MarkdownIt from 'markdown-it';
import 'react-markdown-editor-lite/lib/index.css';
import { Box, Typography, Button, Divider } from '@mui/material';
import { marked } from 'marked';
import {
    Editor, EditorProvider,

    BtnBold,
    BtnItalic,
    BtnUnderline,
    BtnStrikeThrough,
    BtnLink,
    BtnNumberedList,
    BtnUndo,
    BtnRedo,
    BtnClearFormatting,
    Toolbar,
    BtnBulletList
} from 'react-simple-wysiwyg';
import TurndownService from 'turndown';
import { useDispatch } from 'react-redux';
import { editAIContent, fetchAIContents } from '../../store/aiContentSlice';

const mdParser = new MarkdownIt();

const MarkDownEditor = ({ row ,getAIContentData}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [markdownText, setMarkdownText] = useState(marked(row.description) || '');
    const dispatch = useDispatch()
    const handleEditToggle = () => setIsEditing(true);
    const turndownService = new TurndownService();

    const handleSave = () => {
        const markdownOutput = turndownService.turndown(markdownText);
        console.log('Markdown:', markdownOutput);
        dispatch(editAIContent({ id: row.id, values: { body: markdownOutput } })).then(()=>{
           getAIContentData()
        })
        
        setIsEditing(false);
    };

    return (
        <Box className='mt-3'>
            <form onSubmit={() => {
                handleSave();
            }} >

                {isEditing ? (
                    <>
                        <EditorProvider>
                            <Editor
                                id="body"
                                name="body"
                                label="Body"
                                className='m-1'
                                value={markdownText}
                                style={{
                                    maxHeight: '400px',
                                    overflow: "auto"
                                }}

                                onChange={(e) => {
                                    console.log("text", e.target.value);
                                    setMarkdownText(e.target.value)

                                }}
                            >
                                <Toolbar>
                                    <BtnUndo />
                                    <BtnRedo />
                                    <BtnBold />
                                    <BtnItalic />
                                    <BtnUnderline />
                                    <BtnStrikeThrough />
                                    <BtnBulletList />
                                    <BtnLink />
                                    <BtnNumberedList />
                                    <BtnClearFormatting />
                                </Toolbar>
                            </Editor>
                        </EditorProvider>
                        <Box mt={2} display={"flex"} justifyContent={"flex-end"}>
                            <Button variant='contained' onClick={handleSave}>Save</Button>
                            <Button variant="outlined" sx={{ ml: 2 }} onClick={() => { setIsEditing(false) }}>Cancel</Button>
                        </Box>
                    </>
                ) : (
                    <>
                        <Box
                            sx={{
                                maxHeight: '400px', // set your fixed height
                                overflowY: 'auto', // enables vertical scrolling
                            }}
                        >

                            <ReactMarkdown
                            >{row.description}</ReactMarkdown>
                        </Box>
                        <Divider />
                        <Box mt={2} display={"flex"} justifyContent={"flex-end"} >

                            <Button variant='outlined' onClick={handleEditToggle}>Edit</Button>
                        </Box>
                    </>
                )}
            </form>
        </Box>
    );
};

export default MarkDownEditor;
